import { FileProcessorPanel } from "../helpers/FileProcessorPanel";
import { processDemandConstants } from "../../../lib/api_routes/aiToolkit";
import { TOOL_TYPES } from "../../../utils/aiToolkitInfo";

export function DemandConstantsForm() {
  return (
    <FileProcessorPanel
      title="Demand Constants"
      toolType={TOOL_TYPES.DEMAND_CONSTANTS}
      activityKey="ai_toolkit_demand_constants"
      processFn={processDemandConstants}
      downloadFileName="New_Constants.xlsx"
      toolSelectionRoute="/AiToolkit/Supplier_Demand_Constants"
    />
  );
}
